import ToastActions from 'actions/ToastActions';
import CurrentUser from 'auth/CurrentUser';
import { promiseRelationship } from 'chat/utils/ChatPromises';
import AccordionTextWithIconItem from 'components/AccordionBodyItem/AccordionTextWithIconItem';
import Link from 'components/Link';
import AvatarWithTextItem from 'components/AvatarWithTextItem';
import AvatarWithTextItems from 'components/AvatarWithTextItems';
import { ButtonSize } from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import ClipboardTrigger from 'components/ClipboardTrigger';
import Icon from 'components/Icon';
// @ts-ignore
import { EntityType } from 'components/PeopleList/PeopleList';
import Profile from 'components/Profile';
import Text from 'components/Text';
import Textarea from 'components/Textarea';
import Tooltip from 'components/Tooltip';
import TooltipTrigger from 'components/TooltipTrigger';
import RosterConstants from 'constants/RosterConstants';
import Group from 'entities/Group';
// @ts-ignore
import Relationship from 'entities/Relationship';
import { Container } from 'flux/utils';
import { DeviceType, OrganizationRole } from 'globalTypes';
// @ts-ignore
import CopySubscriberDialog from 'groups/components/CopySubscriberDialog';
// @ts-ignore
import GroupMemberFamily from 'groups/components/GroupMemberFamily';
// @ts-ignore
import { GroupProfileType } from 'groups/components/GroupProfile';
import { format } from 'lib/phoneNumbers';
import { filter, isEmpty, sortBy } from 'lodash';
// @ts-ignore
import PhoneCallButton from 'phoneCalls/components/PhoneCallButton';
import React from 'react';
import Modal from 'react-modal';
import SettingsStore from 'stores/SettingsStore';
// @ts-ignore
import StartChatButton from 'user/components/StartChatButton';
// @ts-ignore
import UserActionsMenuButton from 'user/components/UserActionsMenuButton';
// @ts-ignore
import mapGraphQLMemberToUserActionsMenuButtonUser from 'user/lib/mapGraphQLMemberToUserActionsMenuButtonUser';
// @ts-ignore
import UsersAvatarWithText from 'users/components/UsersAvatarWithText';
import errorLogger from 'utils/errorLogger';
import { OrganizationMemberProfile_organizations_members_members } from './queries/__generated__/OrganizationMemberProfile';
import './UsersProfile.scss';
import UsersProfileOrgInfo from './UsersProfileOrgInfo';
// @ts-ignore
import { subtextForMember } from './utils';

import ContactInfo from 'components/ContactInfo';
import ContactInfoDevice from 'components/ContactInfo/ContactInfoDevice';
import AccordionBodyItem from 'components/AccordionBodyItem';
import Feature from 'components/Feature';

export type UserProfileUser = {};

type GroupAvatar = {
  id: number;
  color: string;
  svgUrl: string;
};

type GroupInfo = {
  id: number;
  uuid: string;
  className: string;
  groupAvatar?: GroupAvatar;
  name: string;
  hasRosterSource: boolean;
};

type AdminVisibleDeviceDetails = {
  id: number;
  endpoint: string;
  type: DeviceType;
};

export type UserProfile = {
  id: number;
  uuid: string;
  name: string;
  firstName: string;
  lastName: string;
  signature?: string;
  note: string;
  preferences: {
    preferred_language: string;
  };
  familySummary: {
    parents: ReadonlyArray<{
      id: number;
      uuid: string;
      name?: string;
      color?: string;
      initials?: string;
      profilePictureUrl?: string;
    }>;
    children: ReadonlyArray<{
      id: number;
      uuid: string;
      name?: string;
      color?: string;
      initials?: string;
      profilePictureUrl: string;
    }>;
  };
  userInteractionPermissions: {
    canAddChild: boolean;
    canAddAsGroupOwner: boolean;
    canAddParent: boolean;
    canAssignRole: boolean;
    canBlock: boolean;
    canChangeRole: boolean;
    canChat: boolean;
    canCopyToAnotherGroup: boolean;
    canRemoveFromGroup: boolean;
    canReportToRemind: boolean;
    canStartAChat: boolean;
    canViewProfile: boolean;
    canUnblock: boolean;
    canPhone: boolean;
    canPhoneDenialReason?: string;
    canSeeDevices: boolean;
    canSetNote: boolean;
    canRequestMessageHistory: boolean;
    canGetMessageHistory: boolean;
    canUpdatePreferredLanguage: boolean;
    canChangeName: boolean;
    canBanNameChanges: boolean;
  };
  groupsOwned: ReadonlyArray<GroupInfo>;

  // Specific to org, but set to empty array for group contexts
  roles: OrganizationRole[];
  potentialRoles: ReadonlyArray<{
    role: 'admin' | 'parent' | 'rce' | 'student' | 'teacher' | 'unknown';
    display_role: string;
  }>;

  // Specific to org context
  adminVisibleDeviceDetails?: ReadonlyArray<AdminVisibleDeviceDetails>;
  groupsJoined?: ReadonlyArray<GroupInfo>;
  grade?: string;
  rosteredStatus?: boolean;

  // Specific to group context
  devices: any[];
  groupsInCommon?: ReadonlyArray<
    GroupInfo & {
      isMember: boolean;
    }
  >;

  sisFirstName?: string;
  sisLastName?: string;
};

export type Props = {
  member: UserProfile;
  onBackClicked?: () => void;
  onClose: () => void;
  onGroupClicked: (group: GroupProfileType) => void;
  onFamilyMemberClicked: (user: UserProfile, role: OrganizationRole) => void;
  onPreferredLanguageUpdated?: () => Promise<OrganizationMemberProfile_organizations_members_members | void>;
  onNoteChange?: (note: string) => Promise<any>;
  onUserChanged: () => void;
  trackEvent: (value: string, object?: Object) => void;
  userActionsMenuButton?: React.ReactNode;
  entityUuid?: string;
  entityType?: EntityType;
  entityName?: string;
  onHidePrivateNote?: () => void;
  showPrivateNote?: boolean;
};

type State = {
  addGroupModalRelationship?: Relationship;
  note: string;
  noteChanged: boolean;
  showAddGroupModal: boolean;
  selectedDevice: any;
};

const visibleDeviceTypes = ['landline', 'sms', 'email'];

class UsersProfile extends React.Component<Props, State> {
  static getStores(): Array<any> {
    return [SettingsStore];
  }

  static calculateState(prevState: State, props: Props): State {
    return {
      addGroupModalRelationship: null,
      note: props.member.note,
      noteChanged: false,
      showAddGroupModal: false,
      selectedDevice: undefined,
    };
  }

  constructor(props: Props) {
    super(props);

    this.state = {
      addGroupModalRelationship: null,
      note: props.member.note,
      noteChanged: false,
      showAddGroupModal: false,
      selectedDevice: undefined,
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.showPrivateNote && this.props.showPrivateNote) {
      const noteField: HTMLTextAreaElement | null = document.querySelector(
        "[data-test='note-field']"
      );
      if (noteField) {
        noteField.focus();
      }
    }
  }

  closeModal = () => {
    this.setState({
      addGroupModalRelationship: null,
      showAddGroupModal: false,
    });
  };

  handleDeviceCopy = () => {
    ToastActions.showSuccessToast('Contact information copied to clipboard');
    this.props.trackEvent('user_profile.device.copied');
  };

  hasContactInfo = () => {
    const currentUser = CurrentUser.getUser();
    return currentUser && currentUser.hasFeature('pcc-contact-info.web.july-2021');
  };

  handleEditDevice = (deviceToEdit: any) => {
    if (deviceToEdit) {
      this.setState({
        selectedDevice: deviceToEdit
      });
    }
  };

  adminDevicesList = (devices: AdminVisibleDeviceDetails[]) => {
    const { member } = this.props;
    const { uuid } = member;
    const devicesSorted = sortBy(devices, item => (item.type === 'sms' ? 0 : 1));

    return (
      <AvatarWithTextItems>
        {devicesSorted.map(item => {
          const { endpoint, id, type } = item;

          const isEmail = type === 'email';

          const avatarWithTextItem = (
            <AccordionTextWithIconItem
              icon={isEmail ? 'mail' : 'phone'}
              key={id}
              title={isEmail ? endpoint : format(endpoint)}
              data-test="device-item"
            />
          );

          const deviceWithTooltip = (
            <TooltipTrigger
              placement="top"
              key={`tooltip_trigger${id}`}
              tooltip={
                <Tooltip>
                  Click to copy <Text wrap="force">{endpoint}</Text>
                </Tooltip>
              }>
              <div>
                <ClipboardTrigger text={endpoint} onCopy={this.handleDeviceCopy}>
                  {avatarWithTextItem}
                </ClipboardTrigger>
              </div>
            </TooltipTrigger>
          );

          if (
            this.hasContactInfo() &&
            this.props.entityUuid &&
            this.props.entityType === 'organization'
          ) {
            return (
              <ContactInfoDevice
                key={id}
                deviceId={id}
                deviceEndpoint={format(endpoint)}
                relatedUserUuid={uuid}
                organizationUuid={this.props.entityUuid}
                onEdit={this.handleEditDevice}
                onComplete={() => {
                  // This is a "refetch method"
                  if (this.props.onPreferredLanguageUpdated) {
                    this.props.onPreferredLanguageUpdated();
                  }

                  return ToastActions.showSuccessToast('Contact information removed');
                }}
                onError={errorMessage => {
                  ToastActions.showErrorToast(errorMessage);
                }}
                trackEvent={this.props.trackEvent}
                // This was added because of an issue with backend userProfileQuery
                fallback={deviceWithTooltip}
              />
            );
          }

          return deviceWithTooltip;
        })}

        {this.props.entityUuid && this.props.entityType === 'organization' && (
          <Feature name="pcc-contact-info.web.july-2021">
            <AccordionBodyItem>
              <ContactInfo
                relatedUserUuid={uuid}
                organizationUuid={this.props.entityUuid}
                selectedDevice={this.state.selectedDevice}
                onComplete={value => {
                  // This is a "refetch method"
                  if (this.props.onPreferredLanguageUpdated) {
                    this.props.onPreferredLanguageUpdated();
                  }
                  
                  switch (value) {
                    case 'removed':
                      return ToastActions.showSuccessToast('Removed and added successfully');
                    case 'merged':
                      // This should reload the people list
                      // this.props.onUserChanged(); // commented out because it is unstable
                      return ToastActions.showSuccessToast('Merging... this may take a moment');
                    case 'updated':
                      return ToastActions.showSuccessToast('Contact information updated');
                    default:
                      return ToastActions.showSuccessToast('Contact information added');
                  }
                }}
                onError={errorMessage => {
                  ToastActions.showErrorToast(errorMessage);
                }}
                onHide={() => {
                  this.setState({
                    selectedDevice: undefined
                  });
                }}
              />
            </AccordionBodyItem>
          </Feature>
        )}
      </AvatarWithTextItems>
    );
  };

  groupsList = (groups: ReadonlyArray<GroupInfo>, groupType: 'owned' | 'joined') => {
    const { onGroupClicked, onUserChanged, member } = this.props;
    const {
      userInteractionPermissions: { canRemoveFromGroup },
    } = member;

    if (isEmpty(groups)) {
      return null;
    }

    return (
      <AvatarWithTextItems>
        {groups.map((item: any) => {
          const groupEntity: Group = Group.fromJSON(item);
          return (
            <AvatarWithTextItem
              subtle
              key={item.uuid}
              action={
                groupType === 'joined' ? (
                  <UserActionsMenuButton
                    buttonSize={ButtonSize.large}
                    level="icon"
                    glyphSize="inherit"
                    groupToAdmin={groupEntity}
                    isAdminView
                    showRemoveMember
                    disableRemoveMember={!canRemoveFromGroup}
                    onUserRemoved={onUserChanged}
                    user={mapGraphQLMemberToUserActionsMenuButtonUser(member)}
                    tooltip="More actions"
                    tooltipPlacement="top"
                  />
                ) : null
              }
              group={groupEntity}
              onClick={() => onGroupClicked(item)}
            />
          );
        })}
      </AvatarWithTextItems>
    );
  };

  handleAddGroup = () => {
    promiseRelationship(this.props.member.id)
      .then(relationship => {
        this.setState({
          addGroupModalRelationship: relationship,
          showAddGroupModal: true,
        });
      })
      .catch(errorLogger('PropleListUserPropfile handleAddGroup failed'));
  };

  handleSectionVisibilityChange = (uuidsOfExpandedSections: string[]) => {
    const { member, trackEvent } = this.props;

    if (uuidsOfExpandedSections.includes('Contact information')) {
      trackEvent('user_profile.devices.view', {
        affected_user_uuid: member.uuid,
      });
    }
  };

  handleNoteBlur = () => {
    const { onNoteChange, onHidePrivateNote } = this.props;
    const { note, noteChanged } = this.state;

    if (!noteChanged) {
      if (onHidePrivateNote) {
        onHidePrivateNote();
      }
      return;
    }

    if (onNoteChange) {
      onNoteChange(note)
        .then(() => {
          if (onHidePrivateNote) {
            onHidePrivateNote();
          }
        })
        .catch(() => {
          console.error('unable to hide private note');
        });
    }

    ToastActions.showSuccessToast('Note updated');
    this.setState({ noteChanged: false });
  };

  handleNoteChange = (event: React.SyntheticEvent<HTMLTextAreaElement>) => {
    const { value } = event.currentTarget;

    this.setState(prevState => ({
      note: value,
      noteChanged: prevState.note !== value,
    }));
  };

  adminVisibleDevicesForUser = (user: UserProfile): Array<AdminVisibleDeviceDetails> => {
    if (user.adminVisibleDeviceDetails) {
      return filter(user.adminVisibleDeviceDetails, d => visibleDeviceTypes.includes(d.type));
    }
    return [];
  };

  getSections = () => {
    const { onFamilyMemberClicked, onUserChanged, member, trackEvent } = this.props;
    const {
      roles = [],
      familySummary,
      groupsJoined,
      groupsOwned,
      groupsInCommon,
      userInteractionPermissions,
    } = member;
    const {
      canAddChild,
      canAddParent,
      canCopyToAnotherGroup,
      canSeeDevices,
    } = userInteractionPermissions;
    const { parents, children } = familySummary;
    const familyMemberCount = parents.length + children.length;

    const sections: {
      title: string;
      children: JSX.Element | null;
      count?: number;
      defaultOpen?: boolean;
      collapsible?: boolean;
    }[] = [
      {
        title: 'Family members',
        children: (
          <GroupMemberFamily
            key={member.id}
            canAddChild={canAddChild}
            canAddParent={canAddParent}
            familySummary={familySummary}
            orientation="vertical"
            userId={member.id}
            onFamilyMemberClick={onFamilyMemberClicked}
            onAddFamilyMember={() => {
              trackEvent('user_profile.family_members.added');
              onUserChanged();
            }}
          />
        ),
        count: familyMemberCount,
        defaultOpen:
          !roles.includes(OrganizationRole.teacher) || !roles.includes(OrganizationRole.admin),
      },
      {
        title: 'Classes owned',
        children: this.groupsList(groupsOwned, 'owned'),
        count: groupsOwned.length,
        defaultOpen: roles.includes(OrganizationRole.teacher),
      },
    ];

    if (canSeeDevices && member.adminVisibleDeviceDetails) {
      const devices = this.adminVisibleDevicesForUser(member);

      sections.unshift({
        title: 'Contact information',
        children: this.adminDevicesList(devices),
        count: devices.length,
      });
    }

    if (groupsInCommon) {
      sections.push({
        title: 'Classes shared',
        children: this.groupsList(groupsInCommon, 'joined'),
        count: groupsInCommon.length,
      });
    }

    if (groupsJoined) {
      sections.push({
        title: 'Classes joined',
        children: (
          <React.Fragment>
            {this.groupsList(groupsJoined, 'joined')}
            {canCopyToAnotherGroup && (
              <>
                <div className="vertical-separator"></div>
                <Link weight="semibold" onClick={this.handleAddGroup}>Add to class</Link>
              </>
            )}
          </React.Fragment>
        ),
        count: groupsJoined.length,
      });
    }

    if (this.hasProfileRefresh()) {
      sections.unshift({
        title: this.props.entityName ?? '',
        children: (
          <UsersProfileOrgInfo
            member={this.props.member}
            currentRoles={[CurrentUser.getUser().getRole()]}
            currentUserId={CurrentUser.getUserId()}
            entityUuid={this.props.entityUuid}
          />
        ),
        collapsible: true,
      });
    }

    return sections;
  };

  hasProfileRefresh = () => {
    const currentUser = CurrentUser.getUser();
    return currentUser && currentUser.hasFeature('profile_refresh.web.5-5');
  };

  renderActionButtons = () => {
    const { member, userActionsMenuButton } = this.props;
    const { userInteractionPermissions } = member;

    const { canChat, canPhone, canPhoneDenialReason } = userInteractionPermissions;

    const denialReason = canPhone ? undefined : canPhoneDenialReason || 'feature_not_available';

    return (
      <Buttons fullButtonIndex={0}>
        <StartChatButton
          disabled={!canChat}
          size="xsmall"
          subscriber={member.id}
          text={this.hasProfileRefresh() ? 'Message' : 'Send message'}
        />
        <PhoneCallButton
          calleeName={member.name || ''}
          calleeUuid={member.uuid}
          glyphSize="inherit"
          size="xsmall"
          denialReason={denialReason}
        />
        {userActionsMenuButton}
      </Buttons>
    );
  };

  renderNoteField = () => {
    const { member, showPrivateNote } = this.props;
    const { note } = this.state;
    const { canSetNote } = member.userInteractionPermissions;

    const privateNoteVisibility = showPrivateNote || !!member.note;

    return this.hasProfileRefresh() ? (
      <React.Fragment>
        {privateNoteVisibility && (
          <Textarea
            autofocus={!note}
            disabled={!canSetNote}
            placeholder="Add a private note"
            rows={1}
            value={note}
            onBlur={this.handleNoteBlur}
            onChange={this.handleNoteChange}
            data-test="note-field"
          />
        )}
      </React.Fragment>
    ) : (
      <Textarea
        disabled={!canSetNote}
        placeholder="Add a private note"
        rows={2}
        value={note}
        onBlur={this.handleNoteBlur}
        onChange={this.handleNoteChange}
        data-test="note-field"
      />
    );
  };

  renderRosteredIcon() {
    const { member } = this.props;
    const { rosteredStatus } = member;

    // For the class level people list, we don't load or show rostering info
    if (rosteredStatus === null || rosteredStatus === undefined) {
      return null;
    }

    return (
      <TooltipTrigger
        placement="top"
        tooltip={
          <Tooltip>
            {rosteredStatus ? RosterConstants.rosteredLabel : RosterConstants.notRosteredLabel}
          </Tooltip>
        }>
        <span>
          <Icon
            color={
              rosteredStatus ? RosterConstants.rosteredColor : RosterConstants.notRosteredColor
            }
            name={rosteredStatus ? RosterConstants.rosteredIcon : RosterConstants.notRosteredIcon}
            size="xlarge"
          />
        </span>
      </TooltipTrigger>
    );
  }

  subtextForHeader() {
    const { member } = this.props;
    const { signature } = member;
    const langOpts = SettingsStore.getSetting('languages');
    const preferredLanguage = member?.preferences?.preferred_language;
    let subtext: string = '';

    const memberName = `${member.firstName} ${member.lastName}`;

    if (signature && signature !== memberName) {
      subtext += signature;
    }

    if (preferredLanguage) {
      if (signature && signature !== memberName) {
        subtext += ' • ';
      }
      subtext += langOpts.secondary[preferredLanguage];
    }
    return subtext;
  }

  render() {
    const { addGroupModalRelationship, showAddGroupModal } = this.state;
    const { onBackClicked, onClose, onUserChanged, member } = this.props;

    return (
      <React.Fragment>
        <Profile
          actions={this.renderActionButtons()}
          noteField={this.renderNoteField()}
          sections={this.getSections()}
          onBackClicked={onBackClicked}
          onChange={this.handleSectionVisibilityChange}
          onClose={onClose}
          header={
            this.hasProfileRefresh() ? (
              <UsersAvatarWithText
                avatarSize="medium"
                center={false}
                icon={this.renderRosteredIcon()}
                level="profile"
                subtext={this.subtextForHeader()}
                subtle
                textSize="medium"
                user={member}
              />
            ) : (
              <UsersAvatarWithText
                avatarSize="xxlarge"
                icon={this.renderRosteredIcon()}
                level="primary"
                subtext={subtextForMember(member)}
                user={member}
              />
            )
          }
          className="UsersProfile"
        />
        {addGroupModalRelationship && (
          <Modal isOpen={showAddGroupModal}>
            <CopySubscriberDialog
              relationships={[addGroupModalRelationship]}
              onRequestHide={this.closeModal}
              onSubscribe={onUserChanged}
            />
          </Modal>
        )}
      </React.Fragment>
    );
  }
}

export { UsersProfile };
export default Container.create<Props, State>(UsersProfile, { withProps: true, pure: false });
